export const mocks = {};

export const createMock = ({ objectToMock, mockClass }) => {
  mocks[mockClass.name] = objectToMock;

  Object.getOwnPropertyNames(mockClass.prototype)
    .filter(func => func !== 'constructor')
    .forEach(func => mockClass.prototype[func]());
};

export function Mock(original) {
  return function decorator(copy) {
    createMock({ objectToMock: original, mockClass: copy });
    return (...args) => {
      throw new Error('NOT SUPPORTED');
    };
  };
}
